import { usePaymentProvider } from './use-payment-provider.hook';

export const usePaymentProviderSDKBased = () => {
  const paymentProvider = usePaymentProvider();
  if (paymentProvider.tokenizationMechanism !== 'SDK') {
    throw new Error('Payment provider is not SDK based');
  }
  return paymentProvider;
};
